import RoomOption from '../RoomOption';

import styles from './styles.module.scss';

const Builder = ({
  room,
  roomAccessories,
  state,
  setState,
  toggledAccessory,
  setToggledAccessory,
  onResult,
  activeElementRef,
  isTutorialMode,
  showItemAdded,
  t,
}) => {
  // Check if all accessories in current room are selected
  const allCurrentRoomSelected = roomAccessories.every((accessory) =>
    state.selectedAccessories.some((selected) => selected.key === accessory.key)
  );

  // Get if individual accessory is selected
  const getIsSelected = (key) => {
    if (0 !== state.selectedAccessories.length) {
      return state.selectedAccessories.some(
        (selectedAccessory) => selectedAccessory.key === key
      );
    }
    return false;
  };

  const handleSelect = (accessory) => {
    // Remove if already included
    if (getIsSelected(accessory.key)) {
      setState({
        ...state,
        selectedAccessories: state.selectedAccessories.filter(
          (selected) => selected.key !== accessory.key
        ),
      });
      showItemAdded(0);
    } else {
      setState({
        ...state,
        selectedAccessories: [...state.selectedAccessories, accessory],
      });
      showItemAdded(1);

      // // Adobe tracking
      if (window.globalLmd) {
        window.lmd = window.globalLmd;
        window.lmd.facets = {
          values: `Classroom of the Future page: Facet Value: ${t(room.title)}`,
          Clicks: `Classroom of the Future page: Facet Category: ${t(
            accessory.name
          )}`,
        };
        window._satellite.track('facets_refinement');
      }
    }
  };

  const selectAllRoomOptions = () => {
    // Remove all accessories from room
    if (allCurrentRoomSelected) {
      const updatedRoomOptions = state.selectedAccessories.filter(
        (selected) =>
          !roomAccessories.some((accessory) => accessory.key === selected.key)
      );
      setState({ ...state, selectedAccessories: updatedRoomOptions });
      showItemAdded(0);

      // // Adobe analytics
      if (window.globalLmd) {
        window.lmd = window.globalLmd;
        window.lmd.custom = t('button.remove_room');
        window._satellite.track('CustomInteraction');
      }
      return;
    }

    // Add all accessories for room
    const updatedRoomOptions = [...state.selectedAccessories];
    let newItemCount = 0;

    roomAccessories.forEach((accessory) => {
      if (
        !updatedRoomOptions.some((existing) => existing.key === accessory.key)
      ) {
        updatedRoomOptions.push(accessory);
        newItemCount++;
      }
    });

    setState({ ...state, selectedAccessories: updatedRoomOptions });
    showItemAdded(newItemCount);

    // // Adobe analytics
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.custom = t('button.add_room');
      window._satellite.track('CustomInteraction');
    }
  };

  return (
    <div
      className={styles.builder}
      style={{
        zIndex: isTutorialMode ? '1000' : '1',
        pointerEvents: isTutorialMode ? 'none' : 'auto',
      }}
    >
      <h5>{t(room.title)}</h5>
      <p className={styles.builder__details}>{t(room.description)}</p>
      <ul>
        {roomAccessories.length > 0 &&
          roomAccessories.map((accessory, idx) => (
            <RoomOption
              accessory={accessory}
              key={idx}
              idx={idx}
              isSelected={getIsSelected(accessory.key)}
              handleSelect={handleSelect}
              toggledAccessory={toggledAccessory}
              setToggledAccessory={setToggledAccessory}
              activeElementRef={activeElementRef}
              isTutorialMode={isTutorialMode}
              t={t}
            />
          ))}
      </ul>

      {toggledAccessory === null && (
        <div className={styles.builder__ctas}>
          <button
            className={`${styles.builder__cta} ${styles['builder__cta--secondary']}`}
            onClick={selectAllRoomOptions}
          >
            {allCurrentRoomSelected
              ? t('tool_ui.button.remove_room')
              : t('tool_ui.button.add_room')}
          </button>
          {state.selectedAccessories.length > 0 && (
            <button
              className={`${styles.builder__cta} ${styles['builder__cta--primary']}`}
              onClick={() => onResult()}
            >
              {t('tool_ui.button.view_final')}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Builder;
